module.exports = __webpack_public_path__ + "img/三七.d4492f0f.jpg";